// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import CursorComponent from './pages/cursor';
import '@fortawesome/fontawesome-free/css/all.css';
import { BrowserRouter } from 'react-router-dom';   // 👈 add this
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <BrowserRouter  basename="/">
      <CursorComponent />
      <App />
    </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
